export * from './authentication.services';
export * from './question.services';
export * from './company.services';
export * from './cookies.services';
export * from './topic.services';
export * from './module.services';
export * from './assessment.services';
export * from './industry.services';
export * from './account.services';
export * from './static-data.services';



// WEBPACK FOOTER //
// ./src/services/index.js